export default __webpack_public_path__ + "static/steel-d2e47ca2355ff236cc9d359f6157be01.mp4";